export default {
  sizeSmall: '14px',
  sizeMedium: '16px',
  sizeLarge: '18px',
  labelPadding: '0 8px',
  labelFontWeight: '400'
}
